module.exports = __webpack_public_path__ + "media/images/icons/outlined/amazon-47cc1ea2a6b37f776d91ab1823543a47.svg";